import { signal, effect } from "@preact/signals";

export const QUANTITY_MIN_VALUE = 1;
export const QUANTITY_MAX_VALUE = 9999;

export const counter = signal<number>(1);

export const incrementCounter = () => {
  if (counter.peek() < QUANTITY_MAX_VALUE) {
    counter.value += 1;
  }
};

export const decrementCounter = () => {
  if (counter.peek() > QUANTITY_MIN_VALUE) {
    counter.value -= 1;
  }
};

export const isValidValue = (value: unknown) => {
  const numberValue = Number(value);
  return (
    !isNaN(numberValue) &&
    Number.isInteger(numberValue) &&
    numberValue >= QUANTITY_MIN_VALUE &&
    numberValue <= QUANTITY_MAX_VALUE
  );
};
export const setCounter = (value: number) => {
  counter.value = value;
};

export const resetToMinValue = () => {
  counter.value = QUANTITY_MIN_VALUE;
};

const persistStorageCounterKey = "productsQuantity";

export const updateCounterValueInPersistStorage = () => {
  sessionStorage.setItem(persistStorageCounterKey, counter.value.toString());
};

export const syncCounterWithPersistStorage = () => {
  const counterValue = sessionStorage.getItem(persistStorageCounterKey);
  try {
    if (counterValue) {
      return JSON.parse(counterValue);
    }
    return null;
  } catch {
    return null;
  }
};

export const initCounterFromPersistStorage = () => {
  const parsedValue = syncCounterWithPersistStorage();
  if (parsedValue !== null) {
    setCounter(+parsedValue);
  }

  effect(() => {
    updateCounterValueInPersistStorage();
  });
};
